import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CommanServices } from '@/services/commanServices';
import { toast } from 'sonner';

// Scenarios open inside the *exact same* exercise incident page (scenario mode).
// This loader resolves the scenario's backing incident and redirects to it.
export default function ScenarioPreview() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await CommanServices.getScenario(id);
        const d = res?.data ?? res;
        if (d?.incident_id) {
          navigate(`/incident-details/${d.incident_id}?scenario=1&sid=${d.id}`, { replace: true });
        } else {
          toast.error('Could not open scenario');
          navigate('/scenario-library', { replace: true });
        }
      } catch (e) {
        toast.error('Failed to load scenario');
        navigate('/scenario-library', { replace: true });
      }
    })();
  }, [id, navigate]);

  return (
    <div className="p-10 text-center text-gray-400" data-testid="scenario-preview-loading">
      Opening scenario…
    </div>
  );
}
